import { useContext, useState, useRef, useEffect } from 'react';
import PageContext from './PageContext';
import redMinusIcon from '../../svgs/delete-bin-icon.svg';
import pencilIcon from '../../svgs/pencil-icon.svg';
import PageReadOnlyInput from './PageReadOnlyInput'; 
import PageTooltip from './PageTooltip'; 
import TableInput from './TableInputCopy.jsx';
import TableInputWithValue from './TableInputWithValueCopy.jsx';
import TableDropdown from './TableDropdownWithObjCopy.jsx';
import TableDatePicker from './TableDatePickerCopy.jsx';
import { Button, TableCell, Typography } from '@mui/material';
import addIcon from '../../svgs/plus-icon.svg';


const AddNewSubCompanyRow = ({ row, count, tableHeader }) =>{
    // get context from parent
    const {
        subCompanyDataList, 
        setSubCompanyDataList,  
        showAddAccountIdsModal, 
        setShowAddAccountIdsModal, 
        accountIdsRow, 
        setAccountIdsRow, 
        accountIdsDataList, 
        setAccountIdsDataList, 
        accountIdsTableHeader, 
        subCompanyIdsList, 
        setSubCompanyIdsList, 
        subCompanyErrorList, 
        setSubCompanyErrorList,
        processorList, 
        processorDefaultData, 
        portfolio,  
        billingRateList, 
        editBillingRate, 
        setEditBillingRate, 
        subCompanyDataListLength, 
        setSubCompanyDataListLength, 
        activeList
    } = useContext(PageContext);

    // set state 
    const [companyId, setCompanyId] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [editProcessor, setEditProcessor] = useState(false); 

    // event handler for add account ids click
    const onClick = () => {
        // set sub company row to add to for modal
        setAccountIdsRow(accountIdsRow => accountIdsRow = subCompanyDataList[count]); 
        // show modal to add account ids
        setShowAddAccountIdsModal(showAddAccountIdsModal => showAddAccountIdsModal = true); 
    }

    // function to make processor default value
    const defaultProcessor = () => {
        // find default processor in default processor data
        // check only if portfolio is picked
        if (portfolio != ''){
            for (let i = 0; i < processorDefaultData.length; i++ ){
                if (portfolio == processorDefaultData[i]['incentivetype']){
                    // set processor to default 
                    let tempObj = subCompanyDataList; 
                    tempObj[count]['processorid'] = processorDefaultData[i]['processorid']; 
                    break; 
                }
            }
        }
    }

    // return default processor
    const getDefaultProcessor = () => {
        // find default processor in default processor data
        let processorId; 
        // check only if portfolio is picked
        if (portfolio != ''){
            for (let i = 0; i < processorDefaultData.length; i++ ){
                if (portfolio == processorDefaultData[i]['incentivetype']){
                    processorId = processorDefaultData[i]['processorid']; 
                    break; 
                }
            }
            return processorId; 
        }
        // return empty string if no portfolio
        else {
            return ''; 
        }
    }

    // add row to data list
    const addSubCompany = () =>{ 
        // add to subCompanyDataList
        let temp2 = []; 
        for (let i = 0; i < tableHeader.length; i++){
            temp2.push(tableHeader[i]['columnname']);
        }
        let temp = {
            index: count, 
        };
        temp2.map((el) =>{
            
            if (el == 'blank'){
                temp[el] = false;
            }
            else if (el == 'active'){
                temp[el] = activeList[0];
            }
            else if (el == 'startdate'){
                temp[el] = new Date();
            }
            else if (el == 'enddate'){
                temp[el] = null; 
            }
            else if (el == 'processorid'){
                temp[el] = getDefaultProcessor(); 
            }
            else{
                temp[el] = '';
            }
        });
        console.log('Obj', temp); 
        // add new row to object
        let tempObj = subCompanyDataList; 
        // move bottom row to end of object
        tempObj[(count+1)] = subCompanyDataList[count]; 
        // set new element
        tempObj[count] = temp; 
        // assign to state 
        setSubCompanyDataList(subCompanyDataList => subCompanyDataList = tempObj); 
        console.log('Array', tempObj);      
        // increment length
        setSubCompanyDataListLength(subCompanyDataListLength => subCompanyDataListLength + 1);    
        // set error object 
        let temp5 = {}
        Object.keys(temp2).map((el) => {
            temp5 = {
                ...temp5, 
                el: false, 
            }
        }); 
        // add error object to sub company error list 
        setSubCompanyErrorList(subCompanyErrorList => subCompanyErrorList = [
            ...subCompanyErrorList.slice(0, subCompanyErrorList.length-1), 
            temp5, 
            ...subCompanyErrorList.slice(subCompanyErrorList.length-1, subCompanyErrorList.length)
        ])
        // add list of account ids to accountIdsDataList
        let temp3 = []; 
        for (let i = 0; i < accountIdsTableHeader.length; i++){
            temp3.push(accountIdsTableHeader[i]['columnname']);
        }
        let temp4 = {};
        temp3.map((el) =>{
            if (el == 'blank'){
                temp4 = {...temp4, [el]: true};
            }
            else{
                temp4 = {...temp4, [el]: ''};
            }
        });
        console.log(temp4); 
        setAccountIdsDataList(accountIdsDataList => accountIdsDataList = [
            ...accountIdsDataList, 
            [temp4], 
        ]); 

    }

    // remove row from data list
    const removeSubCompany = (index) =>{
        // set temp object
        let tempObj = subCompanyDataList; 
        // remove row at index
        let length = 0; 
        Object.keys(tempObj).map(el => {
            let num = parseInt(el); 
            // set length; 
            length = num; 
            // overwrite element
            if ( tempObj[(num+1)] && num >= index) {
                tempObj[num] = tempObj[(num+1)]; 
                // update index
                if (tempObj[num]['blank'] == false) {
                    tempObj[num]['index'] = num; 
                }   
            }
        }); 
        // remove last element 
        delete tempObj[length]; 
        console.log(tempObj); 
        // set state 
        setSubCompanyDataList(subCompanyDataList => subCompanyDataList = tempObj);
        // increment length
        setSubCompanyDataListLength(subCompanyDataListLength => subCompanyDataListLength - 1);     
        // remove account ids from account ids data list
        setAccountIdsDataList(accountIdsDataList => accountIdsDataList = [...accountIdsDataList.slice(0, index), ...accountIdsDataList.slice(index + 1, accountIdsDataList.length)]); 
        // remove sub company id from list 
        setSubCompanyIdsList(subCompanyIdsList => subCompanyIdsList = [...subCompanyIdsList.slice(0, index), ...subCompanyIdsList.slice(index + 1, subCompanyIdsList.length)]); 
        // remove error object from error list
        setSubCompanyErrorList(subCompanyErrorList => subCompanyErrorList = [...subCompanyErrorList.slice(0, index), ...subCompanyErrorList.slice(index + 1, subCompanyErrorList.length)]); 
    }

 
    // showCell to determine how to display each column
    const showCell = ( el, tag ) =>{
        if (el == 'blank'){
            if (row[el] == true){
                return <TableCell colSpan={tableHeader.length} align='center' className='p-2 bg-white'>
                        <Button disableRipple onClick={()=>addSubCompany()} 
                            sx={{width:'100%', background:'#E5F2F6' ,border:'#E5F2F6','&:hover': {
                                backgroundColor: '#D9ECF2',
                                },
                                }}
                            >
                            {<div className='d-flex gap-2 align-items-center p-1'>
                                <img src={addIcon}/>
                                <Typography sx={{
                                    textTransform:'none',
                                    color:'#001317',
                                    fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',
                                    fontSize:'12px',
                                    lineHeight:'16px',
                                    fontWeight:'400'}}>
                                        {'Add'}
                                </Typography>
                            </div>}
                        </Button>
                    </TableCell>
            }
            else{
                return <TableCell><img src={redMinusIcon} class='data-table-icon-right' onClick={()=>removeSubCompany(count)}/></TableCell>
            }
        }
        else if (row['blank'] != true && el == 'active'){
            return <TableCell><TableDropdown tag={tag} objKey={'active'} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} optionsList={activeList} width='7.2vw'  showError={subCompanyErrorList[count]['active']}/></TableCell>
        }
        else if (row['blank'] != true && el == 'companyname'){
            return <TableCell><TableInput tag={tag} objKey={'companyname'} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength}  width='14.3vw' showError={subCompanyErrorList[count]['companyname']}/></TableCell>
        }
        else if (row['blank'] != true && el == 'companyid'){
            return <TableCell><TableInputWithValue tag={tag} value={companyId} setValue={setCompanyId} objKey={'companyid'} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} width='14.3vw' showError={subCompanyErrorList[count]['companyid']}/></TableCell>
        }
        else if (row['blank'] != true && el == 'startdate'){
            return <TableCell><TableDatePicker tag={tag} objKey={'startdate'} value={startDate} setValue={setStartDate} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} disable={endDate} indicator={3} width='9vw'/></TableCell>
        }
        else if (row['blank'] != true && el == 'enddate'){
            return <TableCell><TableDatePicker tag={tag} objKey={'enddate'} value={endDate} setValue={setEndDate} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} disable={startDate} indicator={4} width='9vw'/></TableCell>
        }
        else if (row['blank'] != true && el == 'addaccountids'){
            return  <TableCell>
                {/* show edit icon to trigger addAccountIdsModal */}
                <PageTooltip title='Add Account IDs'>
                    <img src={pencilIcon} className='data-table-icon' style={{ marginTop: '6px', marginLeft: '23px'}} onClick={(e)=>onClick(e)}/>
                </PageTooltip>
            </TableCell>
        }
        else if (row['blank'] != true && el == 'processorid' && editProcessor == true){
            return <TableCell><TableDropdown tag={tag} objKey='processorid' list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} optionsList={processorList} width='8vw'  showError={subCompanyErrorList[count]['processorid']}/></TableCell>
        }
        else if (row['blank'] != true && el == 'processorid' && editProcessor == false){
            return <TableCell><PageReadOnlyInput tag={tag} value={subCompanyDataList[count]['processorid']} width='8vw'  /></TableCell>
        }
        else if (row['blank'] != true && el == 'billingrateid' && editBillingRate == true){
            return <TableCell><TableDropdown tag={tag} objKey={'billingrateid'} list={subCompanyDataList} setList={setSubCompanyDataList} count={count} length={subCompanyDataListLength} optionsList={billingRateList} width='8vw'  showError={subCompanyErrorList[count]['billingrateid']}/></TableCell>
        }
    } 

    // useEffect to update processor on portfolio change 
    useEffect(() => {
        console.log('HERERERERE'); 
        if (row['blank'] == false){
            // set processor to default 
            defaultProcessor(); 
            // enable/disable edit based on processor
            if (portfolio != ''){
                // set edit processor
                setEditProcessor(editProcessor => editProcessor = portfolio['editprocessor']); 
                // set edit billing rate 
                setEditBillingRate(editBillingRate => editBillingRate = portfolio['editbillingrate']); 
            }
        }
    }, [portfolio]); 

    // useEffect to add to sub company ids list
    useEffect(() => {
        if (row['blank'] == false && companyId.length > 0 && companyId.length != '') {
            setSubCompanyIdsList(subCompanyIdsList => subCompanyIdsList = [
                ...subCompanyIdsList.slice(0, count),
                companyId, 
                ...subCompanyIdsList.slice(count + 1, subCompanyIdsList.length),  
            ]);
        }
    }, [companyId]); 

    return( 
        <>
            {/* map showCell function over ever column in the row */}
            {tableHeader.map(el => 
                showCell(el['columnname'], el['columntag'])
            )}
        </>
    );
}

export default AddNewSubCompanyRow;